import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { Role } from './role-entity';
import { Itinerary } from '../master-data/itinerary-entity';



export class RoleItinerary extends BaseEntity {

    role            : Role;
    itinerary       : Itinerary;
    rank            : number;	
    theDate         : Date;
    weekDay         : number;

}